import Orders from '@/components/pages/core/order/Orders'
import Order from '@/components/pages/core/order/Order'
import OrderCreate from '@/components/pages/core/order/OrderCreate'
import OrderEdit from '@/components/pages/core/order/OrderEdit'
import OrderMetadata from '@/components/pages/core/order/OrderMetadata'
import CodeStatusStatistics from '@/components/pages/core/order/CodeStatusStatistics'
import ActivateOrder from '@/components/pages/core/order/ActivateOrder'
import Sections from '@/components/pages/core/order/section/Sections'
import Section from '@/components/pages/core/order/section/Section'
import SectionMetadata from '@/components/pages/core/order/section/SectionMetadata'
import Geofence from '@/components/pages/core/Geofence'
import Messages from '@/components/pages/core/order/Messages'
import AtiEdit from '@/components/pages/core/ati/AtiEdit'
import Atis from '@/components/pages/core/ati/Atis'
import AtiGroupEdit from '@/components/pages/core/ati/AtiGroupEdit'
import AtiGroups from '@/components/pages/core/ati/AtiGroups'
import Product from '@/components/pages/core/configuration/product/Product'
import ProductEdit from '@/components/pages/core/configuration/product/ProductEdit'
import ProductMetadata from '@/components/pages/core/configuration/product/ProductMetadata'
import Products from '@/components/pages/core/configuration/product/Products'
import CodeDissector from '@/components/pages/core/dissector/CodeDissector'
import BatchValidator from '@/components/pages/core/validation/BatchValidator'
import BlackList from '@/components/pages/core/validation/BlackList'
import BannedIPs from '@/components/pages/core/system/BannedIPs'
import CodeConfiguration from '@/components/pages/core/configuration/codeconfiguration/CodeConfiguration'
import CodeConfigurations from '@/components/pages/core/configuration/codeconfiguration/CodeConfigurations'
import CreateCodeConfiguration from '@/components/pages/core/configuration/codeconfiguration/CreateCodeConfiguration'
import BanIP from '@/components/pages/core/system/BanIP'
import EntryChannel from '@/components/pages/core/validation/entrychannel/Entrychannel'
import EntryChannels from '@/components/pages/core/validation/entrychannel/Entrychannels'
import EntryChannelEdit from '@/components/pages/core/validation/entrychannel/EntrychannelEdit'
import EditSection from '@/components/pages/core/order/section/EditSection'
import ProductMetadataSchemas from '@/components/pages/core/configuration/productmetadataschema/ProductMetadataSchemas'
import CreateProductMetadataSchema from '@/components/pages/core/configuration/productmetadataschema/CreateProductMetadataSchema'
import ViewProductMetadataSchema from '@/components/pages/core/configuration/productmetadataschema/ViewProductMetadataSchema'
import MetadataSchemas from '@/components/pages/core/configuration/metadataschema/MetadataSchemas'
import CreateMetadataSchema from '@/components/pages/core/configuration/metadataschema/CreateMetadataSchema'
import ViewMetadataSchema from '@/components/pages/core/configuration/metadataschema/ViewMetadataSchema'
import CacheStatus from '@/components/pages/core/system/CacheStatus'
import Authentications from '@/components/pages/core/system/Authentications'
import Events from '@/components/pages/core/system/Events'
import CodeStatuses from '@/components/pages/core/configuration/codestatus/CodeStatuses'
import EditCodeStatus from '@/components/pages/core/configuration/codestatus/EditCodeStatuses'
import SetCodeStatus from '@/components/pages/core/SetCodeStatus'
import SetCodeStatusFileUpload from '@/components/pages/core/SetCodeStatusFileUpload'
import Statistics from '@/components/pages/core/statistic/Statistics'
import ValidationLog from '@/components/pages/core/validation/validationlog/ValidationLog'
import Expansions from '@/components/pages/core/order/code/Expansions'
import Rolls from '@/components/pages/core/order/roll/Rolls'
import Roll from '@/components/pages/core/order/roll/Roll'
import RollCreate from '@/components/pages/core/order/roll/RollCreate'
import ValidationSimulator from '@/components/pages/core/validation/ValidationSimulator'
import TopUpWizard from '@/components/pages/core/order/code/TopUpWizard'

export default [
  {
    path: '/core/orders/order/:id/codes/topup/',
    name: 'topUp',
    component: TopUpWizard,
    meta: {
      title: 'Top Up',
      icon: 'fa fa-qrcode',
      breadcrumb: [
        { path: '#/core/orders', title: 'Orders' },
        { path: '#/core/orders/order/{{ params.id}}', title: 'Order {{ params.id}}' },
        { path: '#/core/orders/order/{{ params.id}}/codes', title: 'Expansions' }
      ]
    }
  },
  {
    path: '/core/orders/order/:orderId/rolls/roll/:rollId',
    component: Roll,
    name: 'roll',
    meta: {
      title: 'Roll {{ params.rollId}}',
      icon: 'fa fa-film',
      breadcrumb: [
        { path: '#/core/orders', title: 'Orders' },
        { path: '#/core/orders/order/{{ params.orderId}}', title: 'Order {{ params.orderId}}' },
        { path: '#/core/orders/order/{{ params.orderId}}/rolls', title: 'Rolls' }
      ]
    }
  },
  {
    path: '/core/orders/order/:id/rolls',
    component: Rolls,
    name: 'rolls',
    meta: {
      title: 'Order {{ params.id}} rolls',
      icon: 'fa fa-film',
      breadcrumb: [
        { path: '#/core/orders', title: 'Orders' },
        { path: '#/core/orders/order/{{ params.id}}', title: 'Order {{ params.id}}' }
      ]
    }
  },
  {
    path: '/core/orders/order/:id/rolls/create',
    component: RollCreate,
    name: 'rollCreate',
    meta: {
      title: 'Order {{ params.id}} rolls',
      icon: 'fa fa-film',
      breadcrumb: [
        { path: '#/core/orders', title: 'Orders' },
        { path: '#/core/orders/order/{{ params.id}}', title: 'Order {{ params.id}}' },
        { path: '#/core/orders/order/{{ params.id}}/rolls', title: 'Rolls' }
      ]
    }
  },
  {
    path: '/core/orders/order/:id/code-status-statistics',
    component: CodeStatusStatistics,
    name: 'codeStatusStatistics',
    meta: {
      title: 'Code Status Statistics',
      icon: 'fa fa-kz-code-status',
      breadcrumb: [
        { path: '#/core/orders', title: 'Orders' },
        { path: '#/core/orders/order/{{ params.id}}', title: 'Order {{ params.id}}' }
      ]
    }
  },
  {
    path: '/core/validation/validationsimulator',
    component: ValidationSimulator,
    name: 'validationSimulator',
    meta: {
      title: 'Validation Simulator',
      icon: 'fa fa-stethoscope'
    }
  },
  {
    path: '/core/validation/validationlog',
    component: ValidationLog,
    name: 'validationLog',
    meta: {
      title: 'Validation Log',
      icon: 'fa fa-list-ol'
    }
  },
  {
    path: '/core/orders/order/:id/codes',
    component: Expansions,
    name: 'expansions',
    meta: {
      title: 'Order Codes',
      icon: 'fa fa-qrcode',
      breadcrumb: [
        { path: '#/core/orders', title: 'Orders' },
        { path: '#/core/orders/order/{{ params.id}}', title: 'Order {{ params.id}}' }
      ]
    }
  },
  {
    path: '/core/orders/codestatuses/file',
    component: SetCodeStatusFileUpload,
    name: 'setCodeStatusFileUpload',
    meta: {
      title: 'Upload File',
      icon: 'fa fa-upload'
    }
  },
  {
    path: '/core/orders/codestatuses',
    component: SetCodeStatus,
    name: 'setCodeStatus',
    meta: {
      title: 'Set Code Statuses',
      icon: 'fa fa-tags'
    }
  },
  {
    path: '/core/orders/statistics/statistic',
    component: Statistics,
    name: 'statistics',
    meta: {
      title: 'Statistics',
      icon: 'fa fa-area-chart'
    }
  },
  {
    path: '/core/system/cachestatus',
    component: CacheStatus,
    name: 'cacheStatus',
    meta: {
      title: 'Cache Status',
      icon: 'fa fa-database'
    }
  },
  {
    path: '/core/orders/order/new',
    component: OrderCreate,
    name: 'orderCreate',
    meta: {
      title: 'Create Order',
      icon: 'fa fa-cart-add',
      breadcrumb: [
        { path: '#/core/orders', title: 'Orders' }
      ]
    }
  },
  {
    path: '/core/orders/order/:id/edit',
    component: OrderEdit,
    name: 'orderEdit',
    meta: {
      title: 'Edit Order - {{ params.id}}',
      icon: 'fa fa-cart-arrow-down',
      breadcrumb: [
        { path: '#/core/orders', title: 'Orders' },
        { path: '#/core/orders/order/{{ params.id}}', title: 'Order {{ params.id}}' }
      ]
    }
  },
  {
    path: '/core/orders/order/:id/metadata',
    component: OrderMetadata,
    name: 'orderMetadata',
    meta: {
      title: 'Order {{ params.id}} Metadata',
      icon: 'fa fa-code',
      breadcrumb: [
        { path: '#/core/orders', title: 'Orders' },
        { path: '#/core/orders/order/{{ params.id}}', title: 'Order {{ params.id}}' }
      ]
    }
  },
  {
    path: '/core/orders/order/:id/activate',
    component: ActivateOrder,
    meta: {
      title: 'Activate Order - {{ params.id}}',
      icon: 'fa fa-fa-cart-arrow-down',
      breadcrumb: [
        { path: '#/core/orders', title: 'Orders' },
        { path: '#/core/orders/order/{{ params.id}}', title: 'Orders {{ params.id}}' }
      ]
    }
  },
  {
    path: '/core/orders/order/:id',
    component: Order,
    name: 'order',
    meta: {
      title: 'Order - {{ params.id}}',
      icon: 'fa fa-cart-arrow-down',
      breadcrumb: [
        { path: '#/core/orders', title: 'Orders' }
      ]
    }
  },
  {
    path: '/core/configuration/codestatuses',
    component: CodeStatuses,
    name: 'codeStatuses',
    meta: {
      title: 'Code Statuses',
      icon: 'fa fa-tags'
    }
  },
  {
    path: '/core/configuration/codestatus/:id/edit',
    component: EditCodeStatus,
    name: 'editCodeStatus',
    meta: {
      title: 'Code Status - {{ params.id}}',
      icon: 'fa fa-tag',
      breadcrumb: [
        { path: '#/core/configuration/codestatuses', title: 'Code Statuses' }
      ]
    }
  },
  {
    path: '/core/configuration/codestatus/new',
    component: EditCodeStatus,
    name: 'newCodeStatus',
    meta: {
      title: 'New Code Status',
      icon: 'fa fa-tag',
      breadcrumb: [
        { path: '#/core/configuration/codestatuses', title: 'Code Statuses' }
      ]
    }
  },
  {
    path: '/core/system/events',
    component: Events,
    name: 'sspEvents',
    meta: {
      title: 'Events',
      icon: ''
    }
  },
  {
    path: '/core/system/authentications',
    component: Authentications,
    name: 'authentications',
    meta: {
      title: 'Authentications',
      icon: 'fa fa-key'
    }
  },
  {
    path: '/core/configuration/metadataschemas',
    component: MetadataSchemas,
    name: 'metadataschemas',
    meta: {
      title: 'Metadata Schemas',
      icon: 'fa fa-code'
    }
  },
  {
    path: '/core/configuration/metadataschema/new',
    component: CreateMetadataSchema,
    name: 'createMetadataSchema',
    meta: {
      title: 'Create Metadata Schema',
      icon: 'fa fa-code',
      breadcrumb: [
        { path: '#/core/configuration/metadataschemas', title: 'Metadata Schemas' }
      ]
    }
  },
  {
    path: '/core/configuration/metadataschema/:id/view',
    component: ViewMetadataSchema,
    name: 'viewMetadataSchema',
    meta: {
      title: 'Metadata Schema - {{ params.id}}',
      icon: 'fa fa-code',
      breadcrumb: [
        { path: '#/core/configuration/metadataschemas', title: 'Metadata Schemas' }
      ]
    }
  },
  {
    path: '/core/configuration/metadataschemas',
    component: MetadataSchemas,
    meta: {
      title: 'Metadata Schemas',
      icon: 'fa fa-code'
    }
  },
  {
    path: '/core/configuration/product-metadata-schema/:name/view',
    component: ViewProductMetadataSchema,
    name: 'viewProductMetadataSchema',
    meta: {
      title: 'Product Metadata Schema - {{ params.name}}',
      icon: 'fa fa-code',
      breadcrumb: [
        { path: '#/core/configuration/product-metadata-schemas', title: 'Product Metadata Schemas' }
      ]
    }
  },
  {
    path: '/core/configuration/product-metadata-schemas',
    component: ProductMetadataSchemas,
    name: 'productMetadataSchemas',
    meta: {
      title: 'Product Metadata Schemas',
      icon: 'fa fa-code',
    }
  },
  {
    path: '/core/configuration/product-metadata-schema/new',
    component: CreateProductMetadataSchema,
    name: 'createProductMetadataSchema',
    meta: {
      title: 'Create Product Metadata Schema',
      icon: 'fa fa-code',
      breadcrumb: [
        { path: '#/core/configuration/product-metadata-schemas', title: 'Product Metadata Schemas' }
      ]
    }
  },
  {
    path: '/core/orders/order/:orderId/section/:sectionId/messages',
    component: Messages,
    name: 'messages',
    meta: {
      title: 'Section validation messages',
      icon: 'fa fa-mail',
      breadcrumb: [
        { path: '#/core/orders', title: 'Orders' },
        { path: '#/core/orders/order/{{ params.orderId}}', title: '  Order {{ params.orderId}}' },
        { path: '#/core/orders/order/{{ params.orderId}}/sections', title: 'Sections' },
        { path: '#/core/orders/order/{{ params.orderId}}/section/{{ params.sectionId}}/view', title: 'Section {{ params.sectionId}}' }
      ]
    }
  },
  {
    path: '/core/orders/order/:orderId/section/:sectionId/metadata',
    component: SectionMetadata,
    name: 'sectionMetadata',
    meta: {
      title: 'Section Metadata',
      icon: 'fa fa-code',
      breadcrumb: [
        { path: '#/core/orders', title: 'Orders' },
        { path: '#/core/orders/order/{{ params.orderId}}', title: '  Order {{ params.orderId}}' },
        { path: '#/core/orders/order/{{ params.orderId}}/sections', title: 'Sections' },
        { path: '#/core/orders/order/{{ params.orderId}}/section/{{ params.sectionId}}/view', title: 'Section {{ params.sectionId}}' }
      ]
    }
  },
  {
    path: '/core/orders/order/:id/sections',
    component: Sections,
    name: 'sections',
    meta: {
      title: 'Sections',
      icon: 'fa fa-kz-section',
      breadcrumb: [
        { path: '#/core/orders', title: 'Orders' },
        { path: '#/core/orders/order/{{ params.id}}', title: 'Order {{ params.id}}' }
      ]
    }
  },
  {
    path: '/core/orders/order/:orderId/section/:sectionId/view',
    component: Section,
    name: 'section',
    meta: {
      title: 'Section {{ params.sectionId}}',
      icon: 'fa fa-kz-section',
      breadcrumb: [
        { path: '#/core/orders', title: 'Orders' },
        { path: '#/core/orders/order/{{ params.orderId }}', title: 'Order {{ params.orderId}}' },
        { path: '#/core/orders/order/{{ params.orderId}}/sections', title: 'Sections' }
      ]
    }
  },
  {
    path: '/core/orders/order/:orderId/section/:sectionId/edit',
    component: EditSection,
    name: 'editSection',
    meta: {
      title: 'Edit section {{ params.sectionId}}',
      icon: 'fa fa-code-fork',
      breadcrumb: [
        { path: '#/core/orders', title: 'Orders' },
        { path: '#/core/orders/order/{{ params.orderId}}', title: 'Order {{ params.orderId}}' },
        { path: '#/core/orders/order/{{ params.orderId}}/sections', title: 'Sections' },
        { path: '#/core/orders/order/{{ params.orderId}}/section/{{ params.sectionId}}/view', title: 'Section {{ params.sectionId}}' }
      ]
    }
  },
  {
    path: '/core/orders/order/:orderId/section/new',
    component: EditSection,
    name: 'newSection',
    meta: {
      title: 'New section',
      icon: 'fa fa-code-fork',
      breadcrumb: [
        { path: '#/core/orders', title: 'Orders' },
        { path: '#/core/orders/order/{{ params.orderId}}', title: 'Order {{ params.orderId}}' },
        { path: '#/core/orders/order/{{ params.orderId}}/sections', title: 'Sections' }
      ]
    }
  },
  {
    path: '/core/orders',
    component: Orders,
    name: 'orders',
    meta: {
      title: 'Orders',
      icon: 'fa fa-cart-arrow-down'
    }
  },
  {
    path: '/core/system/ban',
    component: BanIP,
    name: 'ban',
    meta: {
      title: 'Ban IP',
      icon: 'fa fa-ban',
      breadcrumb: [
        { path: '#/core/system/banned', title: 'Banned IPs' }
      ]
    }
  },
  {
    path: '/core/system/banned',
    component: BannedIPs,
    name: 'banned',
    meta: {
      title: 'Banned IPs',
      icon: 'fa fa-ban'
    }
  },
  {
    path: '/core/order/:id/geofence',
    component: Geofence,
    name: 'geofenceOrder',
    meta: {
      title: 'Geofence',
      icon: 'fa fa-globe',
      breadcrumb: [
        { path: '#/core/orders', title: 'Orders' },
        { path: '#/core/orders/order/{{ params.id}}', title: 'Order {{ params.id}}' }
      ]
    },
  },
  {
    path: '/core/orders/order/:orderId/section/:sectionId/geofence',
    component: Geofence,
    name: 'geofenceSection',
    meta: {
      title: 'Geofence',
      icon: 'fa fa-globe',
      breadcrumb: [
        { path: '#/core/orders', title: 'Orders' },
        { path: '#/core/orders/order/{{ params.orderId}}', title: 'Order {{ params.orderId}}' },
        { path: '#/core/orders/order/{{ params.orderId}}/sections', title: 'Sections' },
        { path: '#/core/orders/order/{{ params.orderId}}/section/{{ params.sectionId}}/view', title: 'Section {{ params.sectionId}}' }
      ]
    }
  },
  {
    path: '/core/configuration/atis',
    component: Atis,
    name: 'atis',
    meta: {
      title: 'Validation responses',
      icon: 'fa fa-comment-o'
    }
  },
  {
    path: '/core/configuration/atigroups',
    component: AtiGroups,
    name: 'atiGroups',
    meta: {
      title: 'Validation response groups',
      icon: 'fa fa-comments-o'
    }
  },
  {
    path: '/core/configuration/atigroups/new',
    component: AtiGroupEdit,
    name: 'atiGroupNew',
    meta: {
      title: 'Validation response group',
      icon: 'fa fa-comments-o',
      breadcrumb: [
        { title: 'Ati Groups', path: '#/core/configuration/atigroups' }
      ]
    }
  },
  {
    path: '/core/configuration/atigroups/:id',
    component: AtiGroupEdit,
    name: 'atiGroupEdit',
    meta: {
      title: 'Validation response group {{ params.id}}',
      icon: 'fa fa-comments-o',
      breadcrumb: [
        { title: 'Ati Groups', path: '#/core/configuration/atigroups' }
      ]
    }
  },
  {
    path: '/core/configuration/atis/ati/new',
    component: AtiEdit,
    name: 'atiNew',
    meta: {
      title: 'New validation response',
      icon: 'fa fa-commenting',
      breadcrumb: [
        { path: '#/core/configuration/atis', title: 'Validation Responses' }
      ]
    }
  },
  {
    path: '/core/configuration/atis/ati/:id',
    component: AtiEdit,
    name: 'atiEdit',
    meta: {
      title: 'Validation response {{ params.id}}',
      icon: 'fa fa-commenting',
      breadcrumb: [
        { path: '#/core/configuration/atis', title: 'Validation Responses' }
      ]
    }
  },
  {
    path: '/core/validation/batchvalidator',
    component: BatchValidator,
    name: 'batchValidator',
    meta: {
      title: 'Batch Validate Kezzlercodes',
      icon: 'fa fa-qrcode'
    }
  },
  {
    path: '/core/validation/blacklist',
    component: BlackList,
    name: 'blacklist',
    meta: {
      title: 'Blacklist',
      icon: 'fa fa-ban'
    }
  },
  {
    path: '/core/configuration/products',
    component: Products,
    name: 'products',
    meta: {
      icon: 'fa fa-cubes',
      title: 'Products'
    }
  },
  {
    path: '/core/configuration/product/new',
    component: ProductEdit,
    name: 'productNew',
    meta: {
      title: 'New Product',
      icon: 'fa fa-cube',
      breadcrumb: [
        { path: '#/core/configuration/products', title: 'Products' }
      ]
    }
  },
  {
    path: '/core/configuration/product/:id',
    component: Product,
    name: 'product',
    meta: {
      title: 'Product {{ params.id}}',
      icon: 'fa fa-cube',
      breadcrumb: [
        { path: '#/core/configuration/products', title: 'Products' }
      ]
    }
  },
  {
    path: '/core/configuration/product/:id/edit',
    component: ProductEdit,
    name: 'productEdit',
    meta: {
      title: 'Edit Product {{ params.id}}',
      icon: 'fa fa-cube',
      breadcrumb: [
        { path: '#/core/configuration/products', title: 'Products' }
      ]
    }
  },
  {
    path: '/core/configuration/product/:id/metadata',
    component: ProductMetadata,
    name: 'productMetadata',
    meta: {
      title: 'Product {{ params.id}} Metadata',
      icon: 'fa fa-code',
      breadcrumb: [
        { path: '#/core/configuration/products', title: 'Products' }
      ]
    }
  },
  {
    path: '/core/code-dissector',
    name: 'dissector',
    component: CodeDissector,
    meta: {
      title: 'Code dissector',
      icon: 'fa fa-qrcode'
    }
  },
  {
    path: '/core/code-dissector/:code',
    name: 'dissectorWithCode',
    component: CodeDissector,
    meta: {
      title: 'Code dissector',
      icon: 'fa fa-qrcode'
    }
  },
  {
    path: '/core/validation/entrychannel/:id',
    name: 'entryChannel',
    component: EntryChannel,
    meta: {
      title: 'Entry Channel {{ params.id}}',
      icon: '',
      breadcrumb: [
        { path: '#/core/validation/entrychannels', title: 'Entry Channels' }
      ]
    }
  },
  {
    path: '/core/validation/entrychannels',
    name: 'entryChannels',
    component: EntryChannels,
    meta: {
      title: 'Entry Channels',
      icon: 'fa fa-wifi'
    }
  },
  {
    path: '/core/validation/entrychannel/:id/edit',
    name: 'entryChannelEdit',
    component: EntryChannelEdit,
    meta: {
      title: 'Entry channel {{ params.id}}',
      icon: 'fa fa-wifi',
      breadcrumb: [
        { path: '#/core/validation/entrychannels', title: 'Entry Channels' },
        { path: '#/core/validation/entrychannel/{{ params.id}}', title: 'Entry Channel {{ params.id}}' }
      ]
    }
  },
  {
    path: '/core/validations/entrychannel/new',
    name: 'entryChannelNew',
    component: EntryChannelEdit,
    meta: {
      title: 'New entry channel',
      icon: 'fa fa-wifi',
      breadcrumb: [
        { path: '#/core/validation/entrychannels', title: 'Entry Channels' }
      ]
    }
  },
  {
    path: '/core/configuration/codeconfiguration/:id',
    component: CodeConfiguration,
    name: 'codeConfiguration',
    meta: {
      title: 'Code Configuration {{ params.id}}',
      icon: 'fa fa-terminal',
      breadcrumb: [
        { path: '#/core/configuration/codeconfigurations', title: 'Code Configurations' }
      ]
    }
  },
  {
    path: '/core/configuration/codeconfigurations',
    component: CodeConfigurations,
    name: 'codeConfigurations',
    meta: {
      title: 'Code Configurations',
      icon: 'fa fa-terminal'
    }
  },
  {
    path: '/core/configuration/codeconfiguration',
    name: 'createCodeConfiguration',
    component: CreateCodeConfiguration,
    meta: {
      title: 'Create Code Configuration',
      icon: 'fa fa-terminal',
      breadcrumb: [
        { path: '#/core/configuration/codeconfigurations', title: 'Code Configurations' }
      ]
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes/core.js